import { render, staticRenderFns } from "./OpenAiIntegration.vue?vue&type=template&id=70a5a881"
import script from "./OpenAiIntegration.vue?vue&type=script&lang=js"
export * from "./OpenAiIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports